/* eslint-disable camelcase */
export enum AdditionalServicesTypes {
  GET_ADDITIONAL_SERVICES_REQUEST = '@additional_services/GET_ADDITIONAL_SERVICES_REQUEST',
  GET_ADDITIONAL_SERVICES_SUCCESS = '@additional_services/GET_ADDITIONAL_SERVICES_SUCCESS',
  GET_ADDITIONAL_SERVICES_FAILURE = '@additional_services/GET_ADDITIONAL_SERVICES_FAILURE',
}

export interface AdditionalServiceTypes {
  nome_servico: string | null;
  valor_boleto: string | null;
  valor_cartao: string | null;
  plano: string;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface AdditionalServicesState {
  additionalServices: Array<AdditionalServiceTypes>;
  readonly request: RequestState;
}
